export default class AppStateListener {
	public openedSidebar: boolean = false;
	public minimizedSidebar: boolean = false;
	public hiddenSidebar: boolean = false;

	private listeners: Function[] = [];

	constructor() {}

	public listen(callback: Function) {
		this.listeners.push(callback);
	}

	setOpenedSidebar(value: boolean) {
		this.openedSidebar = value;
		for(let callback of this.listeners) {
			callback({
				type: 'openedSidebar',
				value: value
			});
		}
	}

	setMinimizedSidebar(value: boolean) {
		this.minimizedSidebar = value;
		for(let callback of this.listeners) {
			callback({ type: 'minimizedSidebar', value: value });
		}
	}

	setHiddenSidebar(value: boolean) {
		this.hiddenSidebar = value;
		for(let callback of this.listeners) {
			callback({ type: 'hiddenSidebar', value: value });
		}
	}
}